// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mt-0";
export var animationContainer = "_mt-1";
export var itemPrice = "_mt-a";
export var itemizedContent = "_mt-9";
export var itemizedHeader = "_mt-7";
export var itemizedRow = "_mt-8";
export var itemizedSection = "_mt-6";
export var modalContent = "_mt-2";
export var orderName = "_mt-3";
export var refundOption = "_mt-4";
export var refundOptionsContainer = "_mt-5";
export var shippingLabel = "_mt-b";
export var totalRow = "_mt-c";